export const ServiceActions = {
    LOAD: 'LOAD',
    CONFIRM: 'CONFIRM',
    DECLINE: 'DECLINE',
};

export const ServiceMutations = {
    SAVING: 'SAVING',
    CONFIRM: 'CONFIRM',
    DECLINE: 'DECLINE',
    REQUEST: 'REQUEST',
    SUCCESS: 'SUCCESS',
    ERROR: 'ERROR',
};


